<template>
  <svg
    width="2"
    height="59"
    viewBox="0 0 2 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 0.908203V58.2693"
      stroke="#858C9A"
      stroke-opacity="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="2 2"
    />
  </svg>
</template>
